import FormCooperatorDetailPage from '@/views/forms/FormCooperatorDetailPage'
import FormLayout from '@/views/layouts/FormLayout'

export default function CooperatorDetail() {
  return (
    <FormLayout>
      <FormCooperatorDetailPage />
    </FormLayout>
  )
}
